/* ============================================================
   STORES.JS — Page-specific scripts for stores.html
   ============================================================ */

const productMap = {};
const stores = [
  {
    name: 'Criminal Records',
    region: 'Metro Atlanta',
    city: 'Atlanta, GA',
    address: '1154 Euclid Ave NE, Atlanta, GA 30307',
    website: 'https://criminalatl.com/',
    directions: 'https://maps.google.com/?q=Criminal+Records+Atlanta',
    notes: 'Iconic Little Five Points shop — music, comics, culture.'
  },
  {
    name: 'Oxford Comics & Games',
    region: 'Metro Atlanta',
    city: 'Atlanta, GA',
    address: '2855 Piedmont Rd NE, Atlanta, GA 30305',
    website: 'https://oxfordcomicsandgames.com/',
    directions: 'https://maps.google.com/?q=Oxford+Comics+Atlanta',
    notes: 'Major Atlanta comic shop in Buckhead.'
  },
  {
    name: 'My Parents\' Basement',
    region: 'Metro Atlanta',
    city: 'Avondale Estates, GA',
    address: '22 N Avondale Rd, Avondale Estates, GA 30002',
    website: 'https://www.myparentsbasementcbcb.com/',
    directions: 'https://maps.google.com/?q=My+Parents+Basement+Avondale+Estates',
    notes: 'Beer bar + comic shop. A neighborhood favorite.'
  },
  {
    name: 'Origin Story Comics',
    region: 'Metro Atlanta',
    city: 'Decatur, GA',
    address: '2899B North Decatur Rd, Decatur, GA 30033',
    website: 'https://www.originstorycomics.com/',
    directions: 'https://maps.google.com/?q=Origin+Story+Comics+Decatur',
    notes: 'Indie comic shop in Decatur.'
  },
  {
    name: 'Dr. No\'s Comics & Games Superstore',
    region: 'Metro Atlanta',
    city: 'Marietta, GA',
    address: '3372 Canton Rd #104, Marietta, GA 30066',
    website: 'https://drnos.com/',
    directions: 'https://maps.google.com/?q=Dr+Nos+Comics+Marietta',
    notes: 'Comics and games superstore in Marietta.'
  },
  {
    name: 'Challenges Games & Comics',
    region: 'Metro Atlanta',
    city: 'Atlanta, GA',
    address: '4800 Briarcliff Rd NE, Suite 1011, Atlanta, GA 30345',
    website: 'https://challengesgames.com/',
    directions: 'https://maps.google.com/?q=Challenges+Games+Comics+Atlanta',
    notes: 'Inside Northlake Mall. Games, comics, and more.'
  },
  {
    name: 'East Atlanta Comics',
    region: 'Metro Atlanta',
    city: 'Atlanta, GA',
    address: '1216 Glenwood Ave SE, Atlanta, GA 30316',
    website: 'https://www.eastatlantacomics.com/',
    directions: 'https://maps.google.com/?q=East+Atlanta+Comics',
    notes: 'East Atlanta\'s local comic shop.'
  },
  {
    name: 'Austin Books',
    region: 'Texas',
    city: 'Austin, TX',
    address: '5002 N Lamar Blvd, Austin, TX 78751',
    website: 'https://austinbooks.com/',
    directions: 'https://maps.google.com/?q=Austin+Books+Austin+TX',
    notes: 'One of the largest comic shops in Texas — 200K+ back issues.'
  }
];
const regionSummaries = {
  'Metro Atlanta': 'Our home base — 7 shops across Atlanta, Decatur, Avondale Estates, and Marietta.',
  'Texas': 'Austin Books in Austin, TX — our first store outside Georgia.'
};
function initialsFromName(name){return name.split(' ').map(word => word[0]).slice(0,2).join('').toUpperCase();}

function createStoreCard(store){const card=document.createElement('article');card.className='store-card';card.dataset.storeName=store.name;card.datasetRegion=store.region;card.setAttribute('data-reveal','');const badge=document.createElement('div');badge.className='store-card__badge';badge.textContent=initialsFromName(store.name);card.appendChild(badge);const left=document.createElement('div');const header=document.createElement('div');header.className='store-card__header';const title=document.createElement('h3');title.className='store-card__name';title.textContent=store.name;const city=document.createElement('span');city.className='store-card__city';city.textContent=store.city;header.append(title,city);left.appendChild(header);const address=document.createElement('address');address.className='store-card__address';address.textContent=store.address;left.appendChild(address);if(store.notes){const note=document.createElement('p');note.className='store-note';note.textContent=store.notes;left.appendChild(note);}const actions=document.createElement('div');actions.className='store-card__actions';if(store.website){const btn=document.createElement('a');btn.href=store.website;btn.target='_blank';btn.rel='noopener';btn.className='btn btn-primary btn-sm';btn.textContent='Visit Website';btn.setAttribute('aria-label',`Visit ${store.name} website`);actions.appendChild(btn);}const dir=document.createElement('a');dir.href=store.directions;dir.target='_blank';dir.rel='noopener';dir.className='btn btn-ghost btn-sm';dir.textContent='Get Directions';dir.setAttribute('aria-label',`Get directions to ${store.name}`);actions.appendChild(dir);card.append(left,actions);return card;}
function renderStores(){const root=document.getElementById('stores-root');if(!root)return;root.innerHTML='';const regions=[...new Set(stores.map(store=>store.region))];regions.forEach(region=>{const block=document.createElement('div');block.className='region-block';const header=document.createElement('div');header.className='region-header';const label=document.createElement('span');label.className='region-label';label.textContent='Region';const title=document.createElement('h2');title.className='region-title';title.textContent=region;const desc=document.createElement('p');desc.className='region-desc';desc.textContent=regionSummaries[region]||'';header.append(label,title,desc);const grid=document.createElement('div');grid.className='store-grid';stores.filter(store=>store.region===region).forEach(store=>grid.appendChild(createStoreCard(store)));block.append(header,grid);root.appendChild(block);});}
renderStores();
const conventions=[
  { name:'MomoCon', city:'Atlanta, GA', dates:'May 21–24, 2026', url:'https://www.momocon.com/' },
  { name:'DreamCon', city:'Houston, TX', dates:'July 10–12, 2026', url:'https://www.dreamconvention.com/' },
  { name:'Lore Convention', city:'Durham, NC', dates:'Sept 26–27, 2026', url:'https://loreconvention.com/' }
];
function renderConventions(){const list=document.getElementById('timeline-list');if(!list)return;list.innerHTML='';conventions.forEach(event=>{const item=document.createElement('article');item.className='timeline__item';item.setAttribute('data-reveal','');const dot=document.createElement('span');dot.className='timeline__dot';const title=document.createElement('h3');title.className='timeline__title';title.textContent=`${event.name} — ${event.city}`;const meta=document.createElement('p');meta.className='timeline__meta';meta.textContent=event.dates;const cta=document.createElement('div');const btn=document.createElement('a');btn.className='btn btn-ghost btn-sm';btn.href=event.url;btn.textContent='Add to Calendar';cta.appendChild(btn);item.append(dot,title,meta,cta);list.appendChild(item);});}
renderConventions();
const storeAlertForm=document.getElementById('store-alert-form');const storeAlertResponse=document.getElementById('store-alert-response');storeAlertForm?.addEventListener('submit',event=>{event.preventDefault();storeAlertResponse.textContent='Thanks — check your inbox.';storeAlertForm.reset();});

// Re-run reveal animations for dynamically created [data-reveal] elements
if (typeof initRevealAnimations === "function") initRevealAnimations();
